import { render, staticRenderFns } from "./DeliveredDialog.vue?vue&type=template&id=35816e7b&"
import script from "./DeliveredDialog.vue?vue&type=script&lang=js&"
export * from "./DeliveredDialog.vue?vue&type=script&lang=js&"
import style0 from "./DeliveredDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports